(function () {
  'use strict';

  if (customElements.get('uc-pistol-bundle')) return;

  class UCPistolBundle extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.variants = this.readVariants();
      this.availableVariants = this.variants.filter(function (variant) {
        return variant.available;
      });
      this.variantIds = new Set(this.variants.map(function (variant) {
        return Number(variant.id);
      }));
      this.quantity = 1;
      this.currencyCode = this.dataset.currency || 'USD';
      this.openIndex = -1;
      this.syncingMainVariant = false;

      var initialVariant = this.getMainVariant() || this.availableVariants[0] || this.variants[0];
      this.selections = [0, 1, 2, 3].map(function () {
        return initialVariant ? Number(initialVariant.id) : null;
      });

      this.quantityButtons = Array.from(this.querySelectorAll('[data-uc-pb-quantity]'));
      this.caseRows = Array.from(this.querySelectorAll('[data-uc-pb-case]'));
      this.nativeSelects = Array.from(this.querySelectorAll('[data-uc-pb-native]'));
      this.addButton = this.querySelector('[data-uc-pb-add]');
      this.summary = this.querySelector('[data-uc-pb-summary]');
      this.message = this.querySelector('[data-uc-pb-message]');
      this.moreControls = this.querySelector('[data-uc-pb-more]');
      this.minusButton = this.querySelector('[data-uc-pb-minus]');
      this.plusButton = this.querySelector('[data-uc-pb-plus]');
      this.countOutput = this.querySelector('[data-uc-pb-count]');

      this.buildComboboxes();
      this.bindEvents();
      this.classList.add('is-enhanced');
      this.render();

      if (!this.availableVariants.length && this.addButton) {
        this.addButton.disabled = true;
        this.addButton.textContent = 'Sold out';
        this.showMessage('All pistol case options are currently sold out.');
      }
    }

    readVariants() {
      var node = this.querySelector('[data-uc-pb-variants]');
      if (!node) return [];

      try {
        return JSON.parse(node.textContent || '[]').map(function (variant) {
          variant.id = Number(variant.id);
          return variant;
        });
      } catch (error) {
        console.error('Pistol bundle variant data could not be read.', error);
        return [];
      }
    }

    getVariant(id) {
      var numericId = Number(id);
      return this.variants.find(function (variant) {
        return Number(variant.id) === numericId;
      }) || null;
    }

    getMainVariant() {
      var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));

      for (var index = 0; index < forms.length; index += 1) {
        var input = forms[index].querySelector('[name="id"]');
        var id = input ? Number(input.value) : NaN;

        if (this.variantIds && this.variantIds.has(id)) {
          return this.getVariant(id);
        }
      }

      return null;
    }

    buildComboboxes() {
      var self = this;
      this.caseRows.forEach(function (row, index) {
        self.buildCombobox(row, index);
      });
    }

    buildCombobox(row, index) {
      var self = this;
        var combo = row.querySelector('[data-uc-pb-combobox]');
        var trigger = combo ? combo.querySelector('.uc-pb__trigger') : null;
        var listbox = combo ? combo.querySelector('.uc-pb__listbox') : null;

        if (!combo || !trigger || !listbox) return;

        var listboxId = 'uc-pb-listbox-' + self.dataset.productId + '-' + (index + 1);
        listbox.id = listboxId;
        trigger.setAttribute('aria-controls', listboxId);

        self.variants.forEach(function (variant, optionIndex) {
          var option = document.createElement('button');
          option.type = 'button';
          option.className = 'uc-pb__option';
          option.id = listboxId + '-option-' + optionIndex;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          option.dataset.variantId = String(variant.id);
          option.disabled = !variant.available;

          var swatch = document.createElement('span');
          swatch.className = 'uc-pb__option-swatch';
          swatch.setAttribute('aria-hidden', 'true');
          self.paintSwatch(swatch, variant);

          var name = document.createElement('span');
          name.textContent = variant.name || variant.title;

          var status = document.createElement('span');
          status.className = 'uc-pb__option-status';
          status.textContent = variant.available ? '' : 'Sold out';

          option.appendChild(swatch);
          option.appendChild(name);
          option.appendChild(status);
          listbox.appendChild(option);

          option.addEventListener('click', function () {
            if (!variant.available) return;
            self.setSelection(index, variant.id, true);
          });

          option.addEventListener('keydown', function (event) {
            self.onOptionKeydown(event, index, option);
          });
        });

        trigger.addEventListener('click', function () {
          self.toggleCombobox(index);
        });

        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            self.openCombobox(index, event.key === 'ArrowUp' ? 'last' : 'selected');
          }

          if (event.key === 'Escape') {
            self.closeCombobox(index, true);
          }
        });

        combo.hidden = false;
    }

    ensureCaseRows(quantity) {
      while (this.caseRows.length < quantity) {
        var index = this.caseRows.length;
        var source = this.caseRows[this.caseRows.length - 1];
        var row = source.cloneNode(true);
        var caseNumber = index + 1;
        var label = row.querySelector('.uc-pb__label');
        var select = row.querySelector('[data-uc-pb-native]');
        var combo = row.querySelector('[data-uc-pb-combobox]');
        var trigger = row.querySelector('.uc-pb__trigger');
        var selectedName = row.querySelector('[data-uc-pb-selected-name]');
        var listbox = row.querySelector('.uc-pb__listbox');
        var labelId = 'uc-pb-label-' + this.dataset.productId + '-' + caseNumber;
        var selectedId = 'uc-pb-selected-' + this.dataset.productId + '-' + caseNumber;

        row.dataset.ucPbCase = String(caseNumber);
        row.hidden = false;
        label.id = labelId;
        label.textContent = 'Case ' + caseNumber;
        select.dataset.ucPbNative = String(caseNumber);
        select.setAttribute('aria-labelledby', labelId);
        combo.dataset.ucPbCombobox = String(caseNumber);
        trigger.setAttribute('aria-labelledby', labelId + ' ' + selectedId);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.removeAttribute('aria-controls');
        selectedName.id = selectedId;
        listbox.id = '';
        listbox.hidden = true;
        listbox.classList.remove('is-up');
        listbox.style.maxHeight = '';
        listbox.replaceChildren();

        var inheritedId = this.selections[index] || this.selections[index - 1] || this.selections[0];
        this.selections[index] = inheritedId;
        select.value = String(inheritedId);

        this.querySelector('[data-uc-pb-cases]').appendChild(row);
        this.caseRows.push(row);
        this.nativeSelects.push(select);
        this.bindNativeSelect(select, index);
        this.buildCombobox(row, index);
      }
    }

    bindEvents() {
      var self = this;

      this.quantityButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          self.setQuantity(Number(button.dataset.ucPbQuantity));
        });

        button.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();

          var current = self.quantityButtons.indexOf(button);
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          var next = (current + direction + self.quantityButtons.length) % self.quantityButtons.length;
          var nextButton = self.quantityButtons[next];
          self.setQuantity(Number(nextButton.dataset.ucPbQuantity));
          nextButton.focus();
        });
      });

      this.nativeSelects.forEach(function (select, index) {
        self.bindNativeSelect(select, index);
      });

      if (this.minusButton) {
        this.minusButton.addEventListener('click', function () {
          if (self.quantity > 4) self.setQuantity(self.quantity - 1);
        });
      }

      if (this.plusButton) {
        this.plusButton.addEventListener('click', function () {
          self.setQuantity(self.quantity + 1);
        });
      }

      if (this.addButton) {
        this.addButton.addEventListener('click', function () {
          self.addToCart();
        });
      }

      document.addEventListener('click', function (event) {
        if (!self.contains(event.target)) {
          self.closeAllComboboxes();
          window.setTimeout(function () {
            if (self.syncingMainVariant) return;
            var mainVariant = self.getMainVariant();
            if (mainVariant && Number(mainVariant.id) !== Number(self.selections[0])) {
              self.setSelection(0, mainVariant.id, false, true);
            }
          }, 80);
        }
      }, true);

      document.addEventListener('change', function (event) {
        if (self.contains(event.target) || self.syncingMainVariant) return;

        window.setTimeout(function () {
          var mainVariant = self.getMainVariant();
          if (mainVariant && Number(mainVariant.id) !== Number(self.selections[0])) {
            self.setSelection(0, mainVariant.id, false, true);
          }
        }, 80);
      }, true);
    }

    bindNativeSelect(select, index) {
      var self = this;
      select.addEventListener('change', function () {
        self.setSelection(index, Number(select.value), false);
      });
    }

    paintSwatch(element, variant) {
      element.style.backgroundImage = variant.swatchImage ? 'url("' + variant.swatchImage + '")' : '';
      element.style.backgroundColor = variant.swatchColor || '#ac6942';
    }

    discountForQuantity() {
      if (this.quantity === 2) return Number(this.dataset.discountTwo);
      if (this.quantity === 3) return Number(this.dataset.discountThree);
      if (this.quantity >= 4) return Number(this.dataset.discountFour);
      return 0;
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: this.currencyCode
        }).format(Number(cents) / 100);
      } catch (error) {
        return '$' + (Number(cents) / 100).toFixed(2);
      }
    }

    setQuantity(quantity) {
      if (quantity < 1) return;
      this.ensureCaseRows(quantity);
      this.quantity = quantity;
      this.closeAllComboboxes();
      this.render();
    }

    setSelection(index, variantId, returnFocus, skipMainSync) {
      var variant = this.getVariant(variantId);
      if (!variant || !variant.available) return;

      this.selections[index] = Number(variant.id);
      this.showMessage('');
      this.updateCase(index);

      if (index === 0 && !skipMainSync) {
        this.syncMainProduct(variant.id);
      }

      if (returnFocus) {
        this.closeCombobox(index, true);
      }
    }

    syncMainProduct(variantId) {
      var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      this.syncingMainVariant = true;

      for (var index = 0; index < forms.length; index += 1) {
        var input = forms[index].querySelector('[name="id"]');
        var currentId = input ? Number(input.value) : NaN;

        if (input && this.variantIds.has(currentId)) {
          input.value = String(variantId);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }

      var self = this;
      window.setTimeout(function () {
        self.syncingMainVariant = false;
      }, 120);
    }

    render() {
      var self = this;
      var discount = this.discountForQuantity();

      this.quantityButtons.forEach(function (button) {
        var buttonQuantity = Number(button.dataset.ucPbQuantity);
        var active = buttonQuantity === 4
          ? self.quantity >= 4
          : buttonQuantity === self.quantity;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      this.caseRows.forEach(function (row, index) {
        row.hidden = index >= self.quantity;
        self.updateCase(index);
      });

      if (this.summary) {
        this.summary.textContent = discount
          ? this.quantity + ' cases - Save ' + discount + '%'
          : '1 case - Regular price';
      }

      if (this.addButton && this.availableVariants.length) {
        this.addButton.textContent = 'Add ' + this.quantity + ' ' + (this.quantity === 1 ? 'case' : 'cases') + ' to cart';
      }

      if (this.moreControls) this.moreControls.hidden = this.quantity < 4;
      if (this.minusButton) this.minusButton.disabled = this.quantity <= 4;
      if (this.countOutput) this.countOutput.textContent = this.quantity + ' cases';
    }

    updateCase(index) {
      var row = this.caseRows[index];
      var variant = this.getVariant(this.selections[index]) || this.availableVariants[0] || this.variants[0];
      if (!row || !variant) return;

      this.selections[index] = Number(variant.id);

      var select = row.querySelector('[data-uc-pb-native]');
      if (select) select.value = String(variant.id);

      var trigger = row.querySelector('.uc-pb__trigger');
      var swatch = row.querySelector('[data-uc-pb-selected-swatch]');
      var name = row.querySelector('[data-uc-pb-selected-name]');
      var options = Array.from(row.querySelectorAll('.uc-pb__option'));
      var regularPrice = row.querySelector('[data-uc-pb-regular-price]');
      var currentPrice = row.querySelector('[data-uc-pb-current-price]');
      var discount = this.discountForQuantity();
      var catalogPrice = Number(variant.price);
      var discountedPrice = Math.round(catalogPrice * (100 - discount) / 100);

      if (swatch) this.paintSwatch(swatch, variant);
      if (name) name.textContent = variant.name || variant.title;
      if (regularPrice) {
        regularPrice.hidden = !discount;
        regularPrice.textContent = discount ? this.formatMoney(catalogPrice) : '';
      }
      if (currentPrice) {
        currentPrice.textContent = discount
          ? this.formatMoney(discountedPrice) + ' each'
          : this.formatMoney(catalogPrice);
      }
      options.forEach(function (option) {
        var selected = Number(option.dataset.variantId) === Number(variant.id);
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    toggleCombobox(index) {
      if (this.openIndex === index) {
        this.closeCombobox(index, true);
      } else {
        this.openCombobox(index, 'selected');
      }
    }

    openCombobox(index, focusTarget) {
      this.closeAllComboboxes(index);

      var row = this.caseRows[index];
      var trigger = row ? row.querySelector('.uc-pb__trigger') : null;
      var listbox = row ? row.querySelector('.uc-pb__listbox') : null;
      if (!trigger || !listbox) return;

      listbox.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      this.openIndex = index;

      var triggerRect = trigger.getBoundingClientRect();
      var spaceBelow = window.innerHeight - triggerRect.bottom - 8;
      var spaceAbove = triggerRect.top - 8;
      var opensUp = spaceBelow < 220 && spaceAbove > spaceBelow;
      var availableSpace = opensUp ? spaceAbove : spaceBelow;
      listbox.classList.toggle('is-up', opensUp);
      listbox.style.maxHeight = Math.max(132, Math.min(260, availableSpace - 8)) + 'px';

      var enabledOptions = Array.from(listbox.querySelectorAll('.uc-pb__option:not(:disabled)'));
      if (!enabledOptions.length) return;

      var target = focusTarget === 'last'
        ? enabledOptions[enabledOptions.length - 1]
        : enabledOptions.find(function (option) {
            return option.getAttribute('aria-selected') === 'true';
          }) || enabledOptions[0];

      target.focus();
    }

    closeCombobox(index, returnFocus) {
      var row = this.caseRows[index];
      var trigger = row ? row.querySelector('.uc-pb__trigger') : null;
      var listbox = row ? row.querySelector('.uc-pb__listbox') : null;

      if (listbox) listbox.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (this.openIndex === index) this.openIndex = -1;
      if (returnFocus && trigger) trigger.focus();
    }

    closeAllComboboxes(exceptIndex) {
      var self = this;
      this.caseRows.forEach(function (row, index) {
        if (index !== exceptIndex) self.closeCombobox(index, false);
      });
    }

    onOptionKeydown(event, index, option) {
      var listbox = option.closest('.uc-pb__listbox');
      var enabledOptions = listbox
        ? Array.from(listbox.querySelectorAll('.uc-pb__option:not(:disabled)'))
        : [];
      var current = enabledOptions.indexOf(option);
      var target = null;

      if (event.key === 'ArrowDown') {
        target = enabledOptions[(current + 1) % enabledOptions.length];
      } else if (event.key === 'ArrowUp') {
        target = enabledOptions[(current - 1 + enabledOptions.length) % enabledOptions.length];
      } else if (event.key === 'Home') {
        target = enabledOptions[0];
      } else if (event.key === 'End') {
        target = enabledOptions[enabledOptions.length - 1];
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.setSelection(index, Number(option.dataset.variantId), true);
        return;
      } else if (event.key === 'Escape') {
        event.preventDefault();
        this.closeCombobox(index, true);
        return;
      } else if (event.key === 'Tab') {
        this.closeCombobox(index, false);
        return;
      }

      if (target) {
        event.preventDefault();
        target.focus();
      }
    }

    groupedItems() {
      var quantities = {};

      this.selections.slice(0, this.quantity).forEach(function (id) {
        quantities[id] = (quantities[id] || 0) + 1;
      });

      return Object.keys(quantities).map(function (id) {
        return {
          id: Number(id),
          quantity: quantities[id]
        };
      });
    }

    async addToCart() {
      var self = this;
      var selectedVariants = this.selections.slice(0, this.quantity).map(function (id) {
        return self.getVariant(id);
      });

      if (selectedVariants.some(function (variant) { return !variant || !variant.available; })) {
        this.showMessage('Choose an available option for every case.');
        return;
      }

      var items = this.groupedItems();
      var originalText = this.addButton.textContent;
      this.addButton.disabled = true;
      this.addButton.textContent = 'Adding...';
      this.showMessage('');

      try {
        var root = window.routes && window.routes.root ? window.routes.root : '/';
        root = root.charAt(root.length - 1) === '/' ? root : root + '/';

        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });
        var parsedState = await response.json();

        if (!response.ok || parsedState.status) {
          throw new Error(parsedState.description || parsedState.message || 'Could not add this bundle.');
        }

        var cartResponse = await fetch(root + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        var cart = cartResponse.ok ? await cartResponse.json() : null;

        document.dispatchEvent(new CustomEvent('cart-update', { detail: parsedState }));
        document.dispatchEvent(new CustomEvent('uc:cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        window.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

        this.addButton.textContent = 'Added to cart';
        this.showMessage(this.quantity + ' ' + (this.quantity === 1 ? 'case was' : 'cases were') + ' added.');

        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          document.dispatchEvent(new CustomEvent('uc:cart:open', { detail: cart }));
          document.body.classList.add('cart-sidebar-show');
          var drawer = document.querySelector('#halo-cart-sidebar');
          if (drawer) drawer.setAttribute('aria-hidden', 'false');
        }
      } catch (error) {
        console.error(error);
        this.addButton.textContent = originalText;
        this.showMessage(error.message || 'Sorry, this bundle could not be added.');
      } finally {
        window.setTimeout(function () {
          self.addButton.disabled = false;
          self.render();
        }, 900);
      }
    }

    showMessage(text) {
      if (this.message) this.message.textContent = text || '';
    }
  }

  customElements.define('uc-pistol-bundle', UCPistolBundle);
})();
